import { isMiniProgram, wechatJSDKConfig } from './util'
import { http, HTTP_URL } from './api'
import wx from 'weixin-js-sdk'

// 地图
export function openMaps(options) {
  isMiniProgram(function (res) {
    if (res) {
      var lon_lat = options.lon_lat_tencent
        ? options.lon_lat_tencent.split(',')
        : ''
      if (lon_lat && wx) {
        let lon = Number(lon_lat[0])
        let lat = Number(lon_lat[1])
        wechatJSDKConfig({
          jsApiList: ['openLocation'],
          success: function () {
            wx.openLocation({
              latitude: lat,
              longitude: lon,
              scale: options.scale || 18,
              name: options.name || '',
              address: options.address || '',
              success: function (res) { },
              fail: function (err) { },
              complete: options.complete || function () { }
            })
          },
          fail: function () { }
        })
      }
    } else {
      window.location.href =
        appPath +
        'html/map.html?lon_lat=' +
        options.lon_lat +
        '&name=' +
        options.name +
        '&address=' +
        options.address +
        '&_rnd=' +
        Math.random()
    }
  })
}

// 支付
export function apply(options) {
  var token = localStorage.getItem('miniappToken')
  if (token) {
    var navigateToUrl =
      '/pages/wxpay/pay?webview=true&order_id=' + options.order_id
    var params = {
      token: token,
      order_id: options.order_id
    }
    // 体检卡支付
    if (options.isCard) {
      params['t'] = 1030
      navigateToUrl += '&isCard=1'
    }
    http({
      url: HTTP_URL.wechatminiPay,
      method: 'get',
      params: params
    }).then(response => {
      navigateToUrl += '&payinfo=' + response
      wx.miniProgram.navigateTo({
        url: navigateToUrl,
        success: function (res) {
          console.log(res)
        },
        fail: function (res) {
          console.log(res)
        }
      })
    })
  }
}

export function changeIndex(vm) {
  if (sessionStorage.getItem('orgEntryInfo')) {
    let info = JSON.parse(sessionStorage.getItem('orgEntryInfo'))
    vm.$router.push({
      name: 'org-detail',
      params: { id: info.org_id }
    })
    return false
  }
  return true
}

// 微信小程序跳转
export function navigateTo(url) {
  wx.miniProgram.switchTab({
    url: url, success: function (res) {
      console.log(res)
    },
    fail: function (res) {
      console.log(res)
    }
  })
}
